import React ,{useEffect, useRef}from 'react'
import {portfolio1} from '../../images'
import "./About.css"
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const About = () =>{
const container = useRef(null)
gsap.registerPlugin(ScrollTrigger)
useEffect(()=>{
    const el = container.current;
    gsap.fromTo(".about__container",{
        scale:0.7
    },{
        scale:1,
        scrollTrigger:{
            trigger:el,
            scrub:true,
        }
    }
)
},[]
)

return (
    <section id="about" ref={container}>
        <div className="section__wrapper about__container">
        <div className="me__container blur-effect"> 
        <div className="photo__container">
            <img src={portfolio1} alt=''/>
        </div>
        </div>
        <div className='section__header'>
            <h2 className="primary__title">About Me</h2>
            <h1 className="title">I AM <span className="color__primary">Mahshid Shirazi
            </span></h1>
            <p className="text__muted description">
                I am a Seneca College graduate in Computer Programming & Data Analysis with a strong foundation in 
                Software Development and Cloud technologies. Through my experience, I have contributed to projects in Computer Vision and cloud-base solutions, 
                applying Agile practices to ensure efficiency and quality. By combining a passion for continuous learning with a drive to explore emerging technologies, I aim to design
                innovative and impactful applications that solve real-world challenges.
            </p>

        </div>
        </div>

    </section>


)
}
export default About 